import Product from 'cpc-license-manager/models/product';
import { belongsTo } from '@ember-data/model';

class TrackAndTrace extends Product {
  @belongsTo('station-feature', { async: false, inverse: null, embedded: true }) features;

  name = 'trackAndTrace';
  label = 'TNT';
}

export default TrackAndTrace;
